import { useRef, useState, useEffect, useContext } from 'react';
import { TextField, Container, Stack, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from 'dayjs';
import { DataGrid, jaJP } from '@mui/x-data-grid';
import { API, PAGE_SIZE, MSG } from "./constantsFront";
import { MsgContext } from '../../App';

const G017InputWord = () => {

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  const [StartPublishDate, setStartPublishDate] = useState(''); // 公開日時1
  const [EndPublishDate, setEndPublishDate] = useState(''); // 公開日時2
  const [InputSearchResult, setInputSearchResult] = useState([]); // 検索結果
  const [pageSize, setPageSize] = useState(PAGE_SIZE); // 1ページ当たりの表示件数

  const navigate = useNavigate();

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  var SearchResult = [];
  var start_publish_date = '';
  var end_publish_date = '';
  var firstValue = 0;
  let body = { authKey: API.API_KEY };

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    firstValue = firstValue + 1;
    inputSearch();

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;

  }, [])

  // ヘッダー
  const columns = [
    { field: 'page_name', headerName: 'ページ名', width: 130 },
    { field: 'product_name', headerName: '品目名 / 添加物', width: 255 },
    { field: 'country_name', headerName: '国名 / 食品カテゴリー', width: 255 },
    { field: 'ip_addr', headerName: 'IPアドレス', width: 150 },
    { field: 'create_date', headerName: '日時', width: 160 },
  ];

  // 検索ボタンクリック処理
  const inputSearch = async (e) => {
    try {
      console.log("検索処理開始");
      const rows = [];

      if (StartPublishDate) {
        start_publish_date = dayjs(StartPublishDate).format('YYYY-MM-DD HH:mm:ss');
      }

      if (EndPublishDate) {
        end_publish_date = dayjs(EndPublishDate).format('YYYY-MM-DD HH:mm:ss');
      }

      body.startdate = start_publish_date;
      body.enddate = end_publish_date;
      body.firstvalue = firstValue;
      const res = await axios.post("/t_search_his/select/search/auth", body);
      // 取得チェック
      if (res.status != 200) {
        return;
      }
      SearchResult = res.data.dataList;

      const res2 = await axios.post("/t_search_his/select/search_additive/auth", body);
      // 取得チェック
      if (res.status != 200) {
        return;
      }
      SearchResult = SearchResult.concat(res2.data.dataList);

      for (var i in SearchResult) {
        var createDate = dayjs(SearchResult[i].create_date).format('YYYY-MM-DD HH:mm:ss');
        rows.push({
          // id: SearchResult[i].search_his_id
          id: SearchResult[i].id
          , page_name: SearchResult[i].page_name
          , product_name: SearchResult[i].product_name
          , country_name: SearchResult[i].country_name
          , ip_addr: SearchResult[i].ip_addr
          , create_date: createDate
        });
      }

      setInputSearchResult(rows);

      if (firstValue == 1) {
        firstValue = 0;
      }

      console.log("検索処理終了");
    } catch (e) {
      console.log("例外が発生しました");
      console.log(e.message);
      setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }
  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg">
                <Stack spacing={2}>
                  <h1>入力ワード一覧</h1>

                  <Stack spacing={2} direction="row">
                    <TextField id="outlined-basic" variant="outlined" label="開始日時" type='datetime-local'
                      style={{ width: 250 }} value={StartPublishDate} onChange={e => { setStartPublishDate(e.target.value) }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />

                    <TextField id="outlined-basic" variant="outlined" label="終了日時" type='datetime-local'
                      style={{ width: 250 }} value={EndPublishDate} onChange={e => { setEndPublishDate(e.target.value) }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <Button onClick={inputSearch} style={{ width: "200px" }}>検索</Button>

                  </Stack>


                  <div style={{ width: '100%' }}>
                    <DataGrid
                      className='DataGrid'
                      columns={columns}
                      rows={InputSearchResult}
                      getRowId={(row) => row.id}  // 一意ID項目
                      autoHeight
                      disableSelectionOnClick
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      pagination
                      localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                    />
                  </div>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default G017InputWord;